<template>
  <DoughnutWrapper :direction="direction" v-if="chartData">
    <template #content><Doughnut :data="chartData" :options="chartOptions" :direction="direction" /></template>
    <template #center v-if="total">
      <template v-if="total.heading || Number.isInteger(total.heading)">
        <h4 v-if="total.html" v-html="total.heading" />
        <h4 v-else>{{ total.heading }}</h4>
        <span v-if="total.subheading">{{ total.subheading }}</span>
      </template>
      <template v-else
        ><h4>{{ total }}</h4></template
      >
    </template>
    <template #dimensions>
      <h3 v-if="heading">{{ heading.label }}</h3>
      <ul v-if="dimensions.length">
        <li v-for="dimension in dimensions" :key="dimension.id">
          <span v-if="dimension.icon">{{ dimension.icon }}</span
          ><span
            v-else-if="dimension.marker"
            class="kvass-doughnut__bg-label"
            :style="{ backgroundColor: dimension.marker }"
          ></span>
          <span>{{ dimension.label }}</span>
          <span v-if="dimension.value">({{ valueComp(dimension) }})</span>
        </li>
      </ul>
    </template>
  </DoughnutWrapper>
  <component v-else :is="fallback.tag || 'p'" v-bind="fallback.props">{{ fallback.label }}</component>
</template>

<script>
import DoughnutWrapper from '@/components/Charts/DoughnutWrapper'
import Doughnut from '@/components/Charts/ChartJS/Doughnut'

export default {
  props: {
    data: Object,
    source: Object,
  },
  computed: {
    direction() {
      if (!this.source || !this.source.direction) return 'column'
      return this.source.direction
    },
    heading() {
      if (!this.source || !this.source.heading) return ''
      return typeof this.source.heading === 'function'
        ? this.source.heading({ data: this.data, source: this.source })
        : this.source.heading
    },
    dimensions() {
      if (!this.source || !this.data) return
      return typeof this.source.dimensions === 'function'
        ? this.source.dimensions({ data: this.data, source: this.source, colors: this.colors })
        : this.source.dimensions
    },
    total() {
      if (!this.source || !this.data || !this.source.total) return
      return typeof this.source.total === 'function'
        ? this.source.total({ data: this.data, source: this.source })
        : this.source.total
    },
    colors() {
      if (!this.source || !this.data) return
      return typeof this.source.colors === 'function'
        ? this.source.colors({ data: this.data, source: this.source })
        : this.source.colors
    },
    chartData() {
      if (!this.data) return null

      const result =
        typeof this.source.data === 'function'
          ? this.source.data({
              source: this.source,
              data: this.data,
              colors: this.colors,
              dimensions: this.dimensions,
            })
          : this.source.data
      return this.defaultOrResult(result)
    },
    chartOptions() {
      if (!this.source.options) return {}
      return this.source.options
    },
    fallback() {
      if (!this.source.fallback) return { label: this.$t('statisticsEmptyState') }
      return typeof this.source.fallback === 'function'
        ? this.source.fallback({ data: this.data, source: this.source })
        : this.source.fallback
    },
  },
  methods: {
    defaultOrResult(result) {
      if (!result.labels || result.labels.length === 0) return null
      if (result.datasets && result.datasets[0].data.filter(v => v === 0).length === result.datasets[0].data.length) {
        return { ...result, datasets: [{ ...result.datasets[0], backgroundColor: '#f9f9f9', data: [100] }] }
      }
      return result
    },
    valueComp(dimension) {
      return typeof dimension.value === 'function'
        ? dimension.value({ source: this.source, data: this.data })
        : dimension.value
    },
  },
  components: {
    Doughnut,
    DoughnutWrapper,
  },
}
</script>

<style lang="scss"></style>
